import { useEffect, useState } from 'react';
import './IndexPageSplash.css';

export default function IndexPageSplash() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide splash after 18 seconds (mobile view only)
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 18000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="index-splash">
      <div className="index-splash-image-container">
        <img
          src="/splash-screen.png"
          alt="Qicino Limited"
          className="index-splash-image"
        />
        <div className="index-splash-loader">
          <div className="index-splash-loader-bar"></div>
        </div>
      </div>
    </div>
  );
}
